/**
 * Environment variables utility for Vite
 * This utility provides a standardized way to access environment variables in both legacy and new formats
 */

/**
 * Get an environment variable by key
 * Supports both the import.meta.env.VITE_* format
 *
 * @param key - The key of the environment variable without the prefix
 * @returns The value of the environment variable or empty string if not found
 */
export const getEnv = (key: string, defaultValue = ""): string => {
  // Try both VITE_ format and old process.env format for compatibility
  // @ts-ignore - import.meta.env is a Vite feature
  const viteValue = import.meta.env[`VITE_${key}`] ?? defaultValue

  // If we have a value from Vite's env system, return it
  return viteValue
}

/**
 * Check if the current environment is production
 * @returns True if in production mode
 */
export const isProduction = (): boolean => {
  // @ts-ignore - import.meta.env is a Vite feature
  return import.meta.env.MODE === "production"
}

/**
 * Check if the current environment is development
 * @returns True if in development mode
 */
export const isDevelopment = (): boolean => {
  // @ts-ignore - import.meta.env is a Vite feature
  return import.meta.env.MODE === "development"
}

/**
 * Check if the current environment is test
 * @returns True if in test mode
 */
export const isTest = (): boolean => {
  // @ts-ignore - import.meta.env is a Vite feature
  return import.meta.env.MODE === "test"
}

/**
 * Check if the current environment is pre-production
 * @returns True if in pre-production mode
 */
export const isPreProduction = (): boolean => {
  // @ts-ignore - import.meta.env is a Vite feature
  return import.meta.env.MODE === "pre-production"
}
